module.exports = __webpack_public_path__ + "static/img/graph.c30893d3.svg";